import { render, staticRenderFns } from "./RmVendorMaintain.vue?vue&type=template&id=086280c0&scoped=true"
import script from "./RmVendorMaintain.vue?vue&type=script&lang=js"
export * from "./RmVendorMaintain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086280c0",
  null
  
)

export default component.exports